import React from "react";
import {
  Box,
} from "@mui/material";
import { VendorInvoiceColumns, MajorClassificationColumns } from "../../../data/DynamicTable/Collumns";
import { allPurchaseInvoiceView } from "../../../data/Axios/queries";
import DynamicTable from "../../../data/DynamicTable/dynamicTable";
import { accountsmanagement } from "../../../config";
import PurchaseInvoiceForm from "./form";

const base_url = accountsmanagement.uri;

const PurchaseInvoice = () => {

  const actions = {
    entity: "Purchase Invoice",
    edit: {
      key: "EDIT",
      button_name: "Edit",
      Show_Button: true,
      permission: "EditPermission",
    },
    add: {
      key: "ADD",
      button_name: "Add",
      Show_Button: true,
      permission: "CreatePermission",
    },
    ViewPurchaseInvoiceLines:{ 
      key: "VIEWPURCHASEINVOICE", 
      button_name: "View Lines", 
      Show_Button: true, 
      permission: "hasNoPermission", 
      roleGroupId: [1, 2, 3, 4], 
    },
    PrintInvoice:{ 
      key: "PRINTINVOICE", 
      button_name: "Print", 
      Show_Button: true, 
      permission: "hasNoPermission", 
      roleGroupId: [1, 2, 3, 4], 
    },
    approvePurchaseInvoice: {
      key: "APPROVEPURCHASEINVOICE",
      button_name: "Approve",
      Show_Button: true,
      permission: "hasNoPermission",
      roleGroupId: [1, 2, 3, 4],
    },
     activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button: true,
     permission: "ActivatePermission",
         modelName: "id",
    inputObjectName: "activateDeactivatePurchaseInvoice",
  },
status: true,
  };

  return (
    <Box m="10px">

      <DynamicTable
        title="Puchase Invoice"
        subtitle="Purchase Invoice"
        columns={VendorInvoiceColumns}
        FormComponent={PurchaseInvoiceForm}
        query={allPurchaseInvoiceView}
        base_url={base_url}
        actions={actions}

      />
    </Box>
  );
}

export default PurchaseInvoice;